/*
  rv-versus.js: the comparison chart's phone switcher (sections/rv-versus.liquid; Cris, 2026-10-04: "when you click on
  different electrolyte types it does a swipe rather than changing the entire chart"). Under 750px the chart shows
  Rhovive and one competitor, picked with radio chips (CSS :has() does the showing, so it works without JS). This adds:
  - the picked competitor's column slides in from the side it comes from (right when moving on, left when going back);
    Rhovive's column stays put. Reduced motion: no slide (rv-versus.css).
  - a sideways swipe on the chart moves to the next or previous competitor (vertical scrolling is untouched).
*/
(() => {
  if (window.rvVersusBound) return;
  window.rvVersusBound = true;

  const init = (sec) => {
    if (sec.dataset.rvVsInit) return;
    sec.dataset.rvVsInit = '1';
    const radios = [...sec.querySelectorAll('.rv-versus__radio')];
    if (radios.length < 2) return;
    let cur = radios.findIndex((r) => r.checked);

    const show = (i) => {
      const dir = i > cur ? 1 : -1;
      cur = i;
      sec.style.setProperty('--rv-vs-dir', String(dir));
      sec.classList.remove('is-vs-anim');
      void sec.offsetWidth; // restart the animation
      sec.classList.add('is-vs-anim');
    };

    radios.forEach((r, i) => r.addEventListener('change', () => { if (r.checked) show(i); }));

    /* every row as tall as its tallest version (one competitor at a time), so switching never moves the chart */
    const rows = [...sec.querySelectorAll('.rv-versus__table tr')];
    const phone = window.matchMedia('(max-width: 749px)');
    const even = () => {
      rows.forEach((tr) => { tr.style.height = ''; });
      if (!phone.matches) return;
      const max = rows.map(() => 0);
      radios.forEach((r) => {
        sec.dataset.vsMeasure = r.value;
        rows.forEach((tr, k) => { max[k] = Math.max(max[k], tr.getBoundingClientRect().height); });
      });
      delete sec.dataset.vsMeasure;
      rows.forEach((tr, k) => { tr.style.height = Math.ceil(max[k]) + 'px'; });
    };
    even();
    let t;
    window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(even, 150); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(even);
    window.addEventListener('load', even);
    sec.addEventListener('load', even, true); // the jar images
    sec.addEventListener('animationend', () => sec.classList.remove('is-vs-anim'));

    const area = sec.querySelector('.rv-versus__scroll');
    if (!area) return;
    let x0 = null;
    let y0 = null;
    area.addEventListener('touchstart', (e) => {
      if (e.touches.length !== 1) return;
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    area.addEventListener('touchend', (e) => {
      if (x0 === null || !window.matchMedia('(max-width: 749px)').matches) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - x0;
      const dy = t.clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      const next = Math.max(0, Math.min(radios.length - 1, cur + (dx < 0 ? 1 : -1)));
      if (next === cur) return;
      radios[next].checked = true;
      radios[next].dispatchEvent(new Event('change', { bubbles: true }));
    }, { passive: true });
  };

  const all = () => document.querySelectorAll('.rv-versus').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();
